import { BidProcessTypeNames } from '@enums/index';

export default function getBidProcessTypeName(processTypeId) {
    return BidProcessTypeNames[processTypeId];
}
